module.exports = "pegasus_template/assets/summer-header.png";